import { DateInput, Create, ReferenceInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { Grid, Typography } from '@mui/material';

const CourseCreate = () => {
	return (
		<Create>
			<SimpleForm>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">פרטי הקורס</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.he" label="כותרת בעברית" fullWidth />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.en" label="כותרת באנגלית" fullWidth />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="description.he" label="תיאור בעברית" fullWidth  multiline rows={8} />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="description.en" label="תיאור באנגלית" fullWidth  multiline rows={8}  />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">לוח זמנים</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<DateInput source="startDate" label="תאריך התחלה" fullWidth />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">מדריך</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<ReferenceInput
							reference="instructor/all"
							source="expert._id"
							label="מדריך"
							filter={{ lnd: true }}
							perPage={999}
						>
							<SelectInput optionText={'name'} optionValue="_id" fullWidth />
						</ReferenceInput>
					</Grid>
				</Grid>
			</SimpleForm>
		</Create>
	);
};
export default CourseCreate;
